import dayjs from 'dayjs'

export const isProduction = process.env.NODE_ENV === 'production'

export const formatDate = (date: number, format = 'YY-MM-DD HH:mm:ss') => {
  return dayjs(date).format(format)
}
